import React from "react";
import { Auth0Provider, AppState } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

/**
 * Reads Auth0 settings from env at build time, falls back to the dev tenant
 * (eleetz.eu.auth0.com) so local previews work without extra setup.
 */
function getConfig() {
  return {
    domain: process.env.REACT_APP_AUTH0_DOMAIN ?? "eleetz.eu.auth0.com",
    clientId:
      process.env.REACT_APP_AUTH0_CLIENT_ID ??
      "S6EwjIoBtmXTPznFnJVIP0n0nnrJQJGq",
    // Default to the same audience the RN app uses (EL-App/app/auth0-configuration.ts)
    // so getAccessTokenSilently() returns an API-scoped JWT.
    audience: process.env.REACT_APP_AUTH0_AUDIENCE ?? "api.eleetz.com",
  };
}

export const Auth0ProviderWithConfig: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const config = getConfig();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || "/", { replace: true });
  };

  return (
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      cacheLocation="localstorage"
      useRefreshTokens
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope: "openid profile email offline_access",
        audience: config.audience,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
